import './AurigalLoader.scss';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { AurigaLoaderProps } from 'types/Common.types';

// Defaults for loader if no override props provided
const BOX_CLASS_NAME = 'auriga-loader__container';
const TEXT_CLASS_NAME = 'auriga-loader__text';
const LOADER_TEXT = 'Loading...';
const LOADER_SIZE = 60;

/**
 * Auriga Loader Component
 *
 * This component displays a loading indicator during various common operations (e.g. Auth, Api init, etc.).
 * It provides visual feedback to users while operations are in progress.
 */
const AurigaLoader = (props: AurigaLoaderProps) => {
  const { boxClassName, textClassName, loaderText, loaderSize } = props;

  return (
    <Box className={boxClassName || BOX_CLASS_NAME}>
      <CircularProgress size={loaderSize || LOADER_SIZE} />
      <Typography variant='h6' className={textClassName || TEXT_CLASS_NAME}>
        {loaderText || LOADER_TEXT}
      </Typography>
    </Box>
  );
};

export default AurigaLoader;
